import React from "react"
import { Helmet } from "react-helmet"

const CreateHead = (props) => {
  const headInfo = {
    title: props.title ? props.title + " | Casa Avó Miquinhas" : "Casa Avó Miquinhas",
    description: props.description
      ? props.description
      : "Design é função, é forma.",
    url: props.url ? props.url : "https://casaavomiquinhas.com",
    image: props.img ? props.img : "/banner.png",
  }

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: props.lang?.toLowerCase() ?? "PT",
        }}
      >
        <title>{headInfo.title}</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, user-scalable=no"
        />
        <meta name="description" content={headInfo.description} />

        <meta name="apple-mobile-web-app-title" content={headInfo.title} />
        <link rel="manifest" href="/site.webmanifest" />

        <meta property="og:url" content={headInfo.url} />
        <meta property="og:title" content={headInfo.title} />
        <meta property="og:description" content={headInfo.description} />
        <link rel="image_src" href={headInfo.image}></link>
        <meta property="og:image" content={headInfo.image} />
        <meta property="og:site_name" content={headInfo.title} />
        <meta name="twitter:title" content={headInfo.title} />
        <meta name="twitter:description" content={headInfo.description} />
        <meta name="twitter:image" content={headInfo.image} />
        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta name="twitter:image:alt" content={headInfo.title}></meta>

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Yeseva+One&display=swap"
          rel="stylesheet"
        />

        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
      </Helmet>
      {props.children}
    </>
  )
}
export default CreateHead
